// extracted by mini-css-extract-plugin
module.exports = {"fill":"optimized-image_fill__Gb1d0"};